export default function queryRoots(selector, root = document) {
    const elements = Array.from(root.querySelectorAll(selector));
    if (root.nodeType === 1 && root.matches(selector)) elements.unshift(root);
    return elements;
}
